export default {
    namespaced: true,

    state: {
        version: "version 1.0",  // version管理
        item: {},
        user: {
            uid: "",
        },
        fsAuth: {},
        snackbar: {
            flag: false,
            color: "",
            msg: "",
            timeout: 2000
        },
        overlay: {
            flag: false,
            msg: ""
        },
        extractDocument: {
            // extractor doc_data初期値 初回はバックエンドで生成するが、v-if判定を無くす為デフォルト追加
            archive: false,
            is_parsed: false,
            is_system_parse: false,
            crawler_info: {
                region: "",
                crawler_type: "aio",
                platform: "random",
                browser: "chrome",
                ignore_regions: [
                    'alibaba-cn-hangzhou',
                    'alibaba-cn-shanghai',
                    'alibaba-cn-beijing',
                    'alibaba-cn-zhangjiakou',
                    'alibaba-cn-shenzhen',
                    'alibaba-cn-hongkong'
                ],
            },
            parsed_columns: []
        },
        crawlerInfoMaster: {},
        extractUserMove: [],
        scdDoc: {},
        planInfo: {},
        counter: {},
        isLoggedIn: false,
        drawerFlag: false
    },

    // 取り出し
    getters: {
        storeItem: (state) => state.item,
        storeUser: (state) => state.user,
        storeSnackbar: (state) => state.snackbar,
        storePolicy: (state) => state.policy,
        storeExpo: (state) => state.planInfo["expo"],
        storeRabbit: (state) => state.planInfo["rabbit"],
        storePlanInfo: (state) => state.planInfo,
        storeCounter: (state) => state.counter,
        storeOverlay: (state) => state.overlay,
        version: (state) => state.version,
        storeIsLoggedIn: (state) => state.isLoggedIn,
        storeDrawerFlag: (state) => state.drawerFlag,
        storeExtractDocument: (state) => state.extractDocument,
        storeExtractUserMove: (state) => state.extractUserMove,
        storeScdDoc: (state) => state.scdDoc,
        storeCrawlerInfoMaster: (state) => state.crawlerInfoMaster
    },
    actions: {
        changeEditItem({commit}, item) {
            commit("changeEditItem", item);
        },
        resetItem({commit}) {
            commit("resetItem");
        },
        setExtractDocument({commit}, extractDocument) {
            commit("setExtractDocument", extractDocument);
        },
        resetExtractDocument({commit}) {
            commit("setExtractDocument", {
                archive: false,
                is_parsed: false,
                is_system_parse: false,
                crawler_info: {
                    region: "",
                    crawler_type: "aio",
                    platform: "random",
                    browser: "chrome",
                    ignore_regions: [
                        'alibaba-cn-hangzhou',
                        'alibaba-cn-shanghai',
                        'alibaba-cn-beijing',
                        'alibaba-cn-zhangjiakou',
                        'alibaba-cn-shenzhen',
                        'alibaba-cn-hongkong'
                    ],
                },
                parsed_columns: []
            })
        },
        setExtractUserMove({commit}, extractUserMove) {
            commit("setExtractUserMove", extractUserMove);
        },
        setCrawlerInfoMaster({commit}, crawlerInfoMaster) {
            commit("setCrawlerInfoMaster", crawlerInfoMaster);
        },
        setScdDoc({commit}, scdDoc) {
            commit("setScdDoc", scdDoc);
        },
        setUser({commit}, user) {
            commit("setUser", user);
        },
        changeAuth({commit}, auth) {
            commit("setAuth", auth);
        },
        changeSnackbar({commit}, snackbar) {
            commit("changeSnackbar", snackbar);
        },
        switchDrawer({commit}, drawerFlag) {
            commit("switchDrawer", drawerFlag);
        },
        switchIsLoggedIn({commit}, isLoggedIn) {
            commit("switchIsLoggedIn", isLoggedIn);
        },
        changePolicy({commit}, policy) {
            commit("changePolicy", policy);
        },
        resetPolicy({commit}) {
            commit("resetPolicy");
        },
        planInfo({commit}, plan) {
            commit("planInfo", plan);
        },
        addCounter({commit}, counter) {
            commit("addCounter", counter);
        },
        /**
         * overlay有効化&&無効化
         * 有効化のときはmsgを入れ、無効化したい場合は引数無しで1回呼び出す
         * @param commit
         * @param msg
         */
        changeOverlay({commit}, msg="") {
            commit("changeOverlay", msg);
        },
    },

    mutations: {
        changeEditItem(state, item) {
            state.item = item;
        },
        setExtractDocument(state, extractDocument) {
            state.extractDocument = extractDocument;
        },
        setExtractUserMove(state, extractUserMove) {
            state.extractUserMove = extractUserMove;
        },
        setCrawlerInfoMaster(state, crawlerInfoMaster) {
            state.crawlerInfoMaster = crawlerInfoMaster;
        },
        setScdDoc(state, scdDoc) {
            state.scdDoc = scdDoc;
        },
        setAuth(state, auth) {
            state.fsAuth = auth;
        },
        resetItem(state) {
            // Edit.vueで空にするときにネストしてる要素はエラーとなるため初期値追加
            state.item = {
                price: [{num: 0}],
                offers: {
                    baseFlag: false,
                    lower: {flag: false},
                    upper: {flag: false}
                },
                pictures: [],
                item_specifics: {}
            };
        },
        switchDrawer(state, drawerFlag) {
            state.drawerFlag = drawerFlag;
        },
        switchIsLoggedIn(state, isLoggedIn) {
            state.isLoggedIn = isLoggedIn;
        },
        setUser(state, user) {
            state.user = { ...state.user, ...user }
        },
        changeSnackbar(state, snackbar) {
            state.snackbar = snackbar
        },
        changePolicy(state, policy) {
            state.policy = policy
        },
        resetPolicy(state) {
            state.policy =
                {
                    fulfillment: "",
                    payment: "",
                    return: ""
                }
        },
        planInfo(state, plan) {
            state.planInfo = plan
        },
        addCounter(state, counter) {
            state.counter = counter
        },
        changeOverlay(state, msg) {
            state.overlay.flag = !state.overlay.flag
            state.overlay.msg = msg
        },
    },
}
;

